import React from 'react'
import DiagnosticsResult from '../DiagnosticsResult'
import { recordingSettings } from '~components/AudioRecording'
import { Status } from '../types'

export default function AudioRecordingChecker(): React.JSX.Element {
  const mimeType = recordingSettings?.web?.mimeType
  const optimal = mimeType?.includes('audio/mp4')
  const status: Status = mimeType === undefined ? 'failed' : optimal ? 'success' : 'inprogress'
  const error: Error | undefined =
    mimeType === undefined
      ? new Error('Audio recording is not supported.')
      : !optimal
        ? new Error('Supported but not optimal (recommend Edge, Chrome or Safari)')
        : undefined

  return (
    <DiagnosticsResult
      title="Audio Recording"
      description="Does the browser support audio recordings"
      status={status}
      error={error}
    />
  )
}
